import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { config } from '../../../../config';

interface AbnLookup {
  name: string;
}

interface AbnLookupResponse {
  data: AbnLookup;
}

@Injectable()
export class AbnService {
  constructor(private http: HttpClient) {}

  lookup(abn: number|string): Observable<AbnLookup> {
    return this.http
      .get<AbnLookupResponse>(`${config.apiLocation}/utils/abn/${abn}`)
      .map(res => res.data)
      .catch(err => Observable.of({ name: '' }));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/utils/abn.service.ts